import { defineMessages } from 'react-intl';
export default defineMessages({
    account: {
        id: 'account.account',
        defaultMessage: 'Profile & Security'
    },
    accountDeleted: {
        id: 'account.accountDeleted',
        defaultMessage: 'Your account has been successfully deleted.'
    },
    accountDescription: {
        id: 'account.accountDescription',
        defaultMessage: 'Name, password, delete account'
    },
    accountSection: {
        id: 'account.accountSection',
        defaultMessage: 'Account'
    },
    changeEmail: {
        id: 'account.changeEmail',
        defaultMessage: 'Change email'
    },
    changePassword: {
        id: 'account.changePassword',
        defaultMessage: 'Change password'
    },
    currentPassword: {
        id: 'account.currentPassword',
        defaultMessage: 'Current password'
    },
    dangerZone: {
        id: 'account.dangerZone',
        defaultMessage: 'Danger zone'
    },
    deleteAccount: {
        id: 'account.deleteAccount',
        defaultMessage: 'Delete your account'
    },
    deleteAccountConfirmation: {
        id: 'account.deleteAccountConfirmation',
        defaultMessage: 'Are you sure you want to delete your account? This action is irreversible.'
    },
    deleteAccountDescription: {
        id: 'account.deleteAccountDescription',
        defaultMessage: 'This action deletes your account and all your information. There is no going back.'
    },
    emailChange: {
        id: 'account.emailChange',
        defaultMessage: 'Change email address'
    },
    emailChangeConfirmation: {
        id: 'account.emailChangeConfirmation',
        defaultMessage: 'Email Change Confirmation'
    },
    emailChangeIntro: {
        id: 'account.emailChangeIntro',
        defaultMessage: 'Enter your new email address and your current password. We will send a link to the new address: your email changes only once you open it.'
    },
    emailChangeFailure: {
        id: 'account.emailChangeFailure',
        defaultMessage: 'The email change link is invalid or has expired.'
    },
    emailChangeSuccess: {
        id: 'account.emailChangeSuccess',
        defaultMessage: 'Your email has been successfully changed to {newEmail}.'
    },
    emailChangeSuccessNoAddress: {
        id: 'account.emailChangeSuccessNoAddress',
        defaultMessage: 'Your email address has been successfully changed.'
    },
    emailChangeVerificationSent: {
        id: 'account.emailChangeVerificationSent',
        defaultMessage: 'A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change.'
    },
    manageAccount: {
        id: 'account.manageAccount',
        defaultMessage: 'Manage account'
    },
    newEmailAddress: {
        id: 'account.newEmailAddress',
        defaultMessage: 'New email address'
    },
    newPassword: {
        id: 'account.newPassword',
        defaultMessage: 'New password'
    },
    newPasswordAgain: {
        id: 'account.newPasswordAgain',
        defaultMessage: 'New password again'
    },
    oldPassword: {
        id: 'account.oldPassword',
        defaultMessage: 'Old password'
    },
    setPassword: {
        id: 'account.setPassword',
        defaultMessage: 'Set a password'
    },
    setPasswordDescription: {
        id: 'account.setPasswordDescription',
        defaultMessage: 'Your account has no password yet'
    },
    noPasswordExplanation: {
        id: 'account.noPasswordExplanation',
        defaultMessage: "Your account doesn't have a SmartMixin password yet, because you sign in with Google, Apple or Facebook. We'll email you a link to set one. You stay signed in."
    },
    emailChangeNeedsPassword: {
        id: 'account.emailChangeNeedsPassword',
        defaultMessage: "To change your email address, first set a password. We'll email you a link to set one. You stay signed in."
    },
    emailChangeSetPasswordFirst: {
        id: 'account.emailChangeSetPasswordFirst',
        defaultMessage: 'To change your email address, first set a password.'
    },
    setPasswordFirst: {
        id: 'account.setPasswordFirst',
        defaultMessage: 'Set a password first'
    },
    sendSetPasswordLink: {
        id: 'account.sendSetPasswordLink',
        defaultMessage: 'Email me a link'
    },
    sendSetPasswordLinkLong: {
        id: 'account.sendSetPasswordLinkLong',
        defaultMessage: 'Email me a link to set a password'
    },
    setPasswordLinkSent: {
        id: 'account.setPasswordLinkSent',
        defaultMessage: "We've sent a link to {email}. Open it to choose your password, then come back here."
    },
    setPasswordLinkResend: {
        id: 'account.setPasswordLinkResend',
        defaultMessage: 'Send again'
    },
    setPasswordLinkError: {
        id: 'account.setPasswordLinkError',
        defaultMessage: "We couldn't send the link. Check your connection and try again."
    },
    setPasswordLinkRetry: {
        id: 'account.setPasswordLinkRetry',
        defaultMessage: 'Try again'
    },
    setPasswordLinkRateLimited: {
        id: 'account.setPasswordLinkRateLimited',
        defaultMessage: "You've asked for several links in a short time. Check your inbox and spam folder for the latest one, or try again later."
    },
    reauthConfirmTitle: {
        id: 'account.reauthConfirmTitle',
        defaultMessage: "Confirm it's you"
    },
    reauthConfirmBody: {
        id: 'account.reauthConfirmBody',
        defaultMessage: 'To change your email address, confirm with the account you sign in with.'
    },
    reauthSetPasswordInstead: {
        id: 'account.reauthSetPasswordInstead',
        defaultMessage: 'Set a password instead'
    },
    reauthConfirmed: {
        id: 'account.reauthConfirmed',
        defaultMessage: 'Confirmed with {provider}'
    },
    reauthExpired: {
        id: 'account.reauthExpired',
        defaultMessage: 'Your confirmation has expired. Confirm again to continue.'
    },
    reauthAccountMismatchGoogle: {
        id: 'account.reauthAccountMismatchGoogle',
        defaultMessage: "That Google account isn't the one linked to SmartMixin. Try again and choose the Google account you sign in with."
    },
    reauthAccountMismatchGoogleNamed: {
        id: 'account.reauthAccountMismatchGoogleNamed',
        defaultMessage: "That Google account isn't the one linked to SmartMixin. Try again and choose {email}."
    },
    reauthAccountMismatchApple: {
        id: 'account.reauthAccountMismatchApple',
        defaultMessage: "That Apple Account isn't the one linked to SmartMixin. Try again with the Apple Account you sign in with."
    },
    reauthFailed: {
        id: 'account.reauthFailed',
        defaultMessage: "We couldn't confirm it's you. Try again."
    },
    reauthProviderUnavailable: {
        id: 'account.reauthProviderUnavailable',
        defaultMessage: "{provider} isn't responding right now. Try again in a few minutes."
    },
    reauthPopupBlocked: {
        id: 'account.reauthPopupBlocked',
        defaultMessage: 'Your browser blocked the Apple window. Press the button again.'
    },
    reauthThrottled: {
        id: 'account.reauthThrottled',
        defaultMessage: "You've tried to confirm several times in a short time. Try again later."
    },
    passwordChange: {
        id: 'account.passwordChange',
        defaultMessage: 'Password change'
    },
    passwordChangeDescription: {
        id: 'account.passwordChangeDescription',
        defaultMessage: 'Keep your account secure'
    },
    passwordUpdated: {
        id: 'account.passwordUpdated',
        defaultMessage: 'Password successfully updated.'
    },
    profile: {
        id: 'account.profile',
        defaultMessage: 'Profile'
    },
    profileUpdated: {
        id: 'account.profileUpdated',
        defaultMessage: 'Profile successfully updated.'
    },
    signedInAs: {
        id: 'account.signedInAs',
        defaultMessage: 'Signed in as'
    },
    updateYourProfile: {
        id: 'account.updateYourProfile',
        defaultMessage: 'Update your profile'
    },
    updateYourProfileDescription: {
        id: 'account.updateYourProfileDescription',
        defaultMessage: 'Name and display preferences'
    }
});
